var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: "600px",
    height: "600px",
    xlink: "http://www.w3.org/1999/xlink",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper",
    transform: "scale(3 3)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3276",
    d: "M225 225H-25V-25h250V225z",
    fill: "#ecf0f1",
    strokeWidth: "none",
    opacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-subwrapper",
    transform: "matrix(0.84999948 0 0 0.84999948 15.000126744483666 17.015025091630633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3253",
    d: "M100.5,100.5h-1v-1h1V100.5z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2893",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2894",
    d: "M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z",
    fill: "#ffe4d6",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2895",
    d: "M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2896",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3050",
    d: "M100.002 170.866c11.391 0 16.629-6.36 24.218-9.638 -0.008-7.932 2.039-23.933 3.282-32.907 -16.136-1.852-38.871-1.852-55.006 0.001 1.243 8.973 3.29 24.972 3.281 32.903C83.37 164.502 88.608 170.866 100.002 170.866z",
    fill: "url(#SvgjsLinearGradient3051)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3267",
    d: "M42.77 235.757l1.323-60.852c0 0 10.194-2.487 16.635-6.313 17.496 21.953 69.451 17.333 78.336-0.62 1.489 0.525 2.721 1.197 4.262 1.713 5 3.386 9.213 4.494 9.213 4.494l0.935 61.685C139.188 236.052 42.77 235.757 42.77 235.757z",
    fill: "#f5f4f5",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3268",
    d: "M154.014 177.705c-4.236-0.719-7.611-1.697-9.452-3.544 -5.343 10.025-26.763 16.378-33.855 17.309 20.554-6.276 29.188-10.813 32.598-21.583 1.99 2.383 6.522 3.549 12.313 4.538L154.014 177.705zM52.67 174.381c1.454-0.312 2.18-1.234 3.623-1.593l-1.528-1.867c-3.114 2.234-8.971 3.305-15.9 4.424l0.188 3.738c3.956-0.79 7.817-1.788 11.429-3.323 7.483 8.485 19.168 12.659 31.06 14.387C66.624 186.562 58.07 180.511 52.67 174.381z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3269",
    d: "M137.861 170.055c-5.929 11.361-50.74 24.595-76.009 0.866 -1.571 0.615-6.271 2.085-6.271 2.085 18.406 23.08 72.345 23.227 86.702-0.112C142.221 172.87 139.321 170.737 137.861 170.055z",
    fill: "#dfdde2",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3270",
    d: "M139.008 167.841c-10.087 18.575-62.578 21.204-78.239 0.625 -5.72 1.556-11.219 4.876-16.756 5.707l-1.243 61.584 110.703 0.107 -0.855-62.386c-3.369-0.707-6.501-2.737-9.254-3.894C141.842 168.945 140.55 168.37 139.008 167.841zM60.39 169.087c13.903 23.086 68.817 18.455 79.419 0.099 1.286 0.499 1.615 0.696 3.106 1.183 -10.982 21.208-65.306 27.967-87.525 1.147C55.546 171.476 58.823 169.629 60.39 169.087zM54.287 172.418c17.963 27.046 77.26 22.856 89.583-1.287 1.771 1.391 4.53 2.989 7.936 3.735l1.66 59.08 -110.377 0.016 1.904-58.299C47.777 174.264 52.247 173.232 54.287 172.418z",
    fill: "#b8b6c9",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3271",
    d: "M-4.529 235.566c-2.574-13.852-2.292-47.592 9.013-47.521 13.136-5.311 29.269-11.404 42.802-15.311 6.908-7.246 13.436-14.137 26.188-21.314 0.389 2.599 1.874 8.541 0.011 11.773 -1.355 2.352-5.783 5.576-9.554 8.368 -2.029 2.72-3.927 5.374-6.599 9.089 5.168 22.301 9.601 33.78 10.097 53.123 0 0-1.452 0.689 64.471 0.397 2.215-22.339 4.993-33.561 10.379-54.098 0 0-4.308-5.014-7.207-8.87 -2.054-1.997-8.36-7.532-8.84-8.651 -1.175-2.741-0.548-6.188 0.11-11.367 10.793 4.873 17 12.021 26.082 21.303 7.729 2.119 30.86 9.967 42.445 15.216 3.965-0.11 6.203 1.999 7.872 5.466 5.405 11.195 4.126 27.297 2.18 42.789C185.83 235.989 49.887 238.17-4.529 235.566z",
    fill: "#386e77",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3272",
    d: "M73.875 154.081c0.16 1.07 0.304 2.085 0.411 3.041 -0.218 0.266-17.212 23.353-17.336 23.525C61.126 171.148 67.1 161.305 73.875 154.081zM126.053 154.081c-0.159 1.07-0.184 2.085-0.291 3.041 0.218 0.266 16.931 22.469 17.054 22.642C138.391 170.914 132.828 161.305 126.053 154.081zM165.008 185.154c-4.28 6.231-5.194 8.382-9.879 14.557 1.071 0 2.799 0.166 3.87 0.166C162.663 193.592 162.67 190.393 165.008 185.154zM169.394 230.379c3.793-8.9 6.934-16.711 10.739-25.624l-1.247-2.014C175.717 211.896 172.354 221.199 169.394 230.379zM41.048 199.877c1.071 0 2.799-0.166 3.871-0.166 -4.685-6.175-5.599-6.561-9.878-12.792C37.377 192.158 37.384 193.592 41.048 199.877zM21.161 202.741l-1.247 2.014c3.806 8.913 4.765 16.724 8.559 25.624C25.512 221.199 24.33 211.896 21.161 202.741z",
    fill: "#265e68",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3273",
    d: "M65.638 169.283c1.181-1.646 5.237-7.272 8.601-12.561C75.227 162.179 73.413 165.416 65.638 169.283zM125.74 156.36c2.553 4.396 5.562 8.772 8.664 12.803C126 165.336 125.435 161.423 125.74 156.36z",
    fill: "#184f58",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3274",
    d: "M126.318 151.359c0.008-0.061 0.017-0.118 0.023-0.174 18.093 9.999 28.576 25.02 40.747 36.217 -0.448 0.721-1.228 1.193-1.687 1.905C152.656 179.609 146.599 164.946 126.318 151.359zM71.736 152.022c-15.034 8.213-36.242 33.357-38.318 35.269 0.448 0.724 0.691 0.577 1.15 1.288C47.314 178.882 50.793 169.283 71.736 152.022zM194.869 187.704c-1-0.799-24.646-10.039-42.59-14.969 33.698 16.299 45.587 18.545 51.471 24.321C203.367 196.057 202.586 187.489 194.869 187.704zM47.458 172.555c-13.524 3.914-30.839 10.098-42.975 15.491 -5.364 0.106-9.208 7.93-10.031 16.084C1.914 187.317-1.773 198.62 47.458 172.555z",
    fill: "#4d7e86",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3275",
    d: "M206.6 210.062c-0.34-8.635-3.055-23.103-11.691-22.46 -0.714-0.61-20.822-9.767-42.285-15.611 -7.353-7.455-16.515-17.598-26.371-20.957 -0.711 6.428-1.477 10.622 0.216 12.714 2.241 2.439 4.93 4.879 7.568 6.522 4.616 6.136 8.139 9.778 8.139 9.778 -5.43 20.703-8.815 31.314-10.973 53.688H68.798c-2.157-22.373-5.543-32.984-10.973-53.688 0 0 3.522-3.643 8.139-9.778 2.639-1.644 5.327-4.083 7.568-6.522 1.692-2.092 0.927-6.286 0.216-12.714 -9.856 3.359-19.019 13.502-26.371 20.957 -21.463 5.845-41.571 15.001-42.285 15.611 -8.637-0.643-11.352 13.825-11.691 22.46 -0.411 10.487 1.435 24.938 1.585 25.938h210.029C205.165 234.999 207.011 220.549 206.6 210.062zM72.984 163.194c-2.258 2.233-3.658 3.181-6.473 5.282 4.829-6.271 4.341-5.433 7.708-11.229C74.37 159.739 73.433 162.751 72.984 163.194zM-3.172 234.028c-1.082-12.844-2.916-24.41 0.43-36.992 1.281-4.827 2.484-8.095 7.455-8.509 1.067 5.538 8.132 28.724 14.298 44.533 -6.226-24.192-5.311-18.81-8.219-28.452 -0.964-3.235-1.854-6.486-2.979-9.672 -0.783-2.214-1.65-4.387-2.262-6.653l40.433-14.865c-0.279 0.283-12.895 13.434-13.199 13.804 1.847 3.021 7.816 7.222 10.845 11.758 -12.436 1.174-18.508 3.173-23 3.84 0.331 0.919 9.061 25.353 9.976 27.656 -1.479-7.917-4.816-20.297-8.637-27.211 1.41-0.179 18.077-2.492 23.393-3.477 -1.476-2.854-8.043-8.437-11.559-12.619 20.646-18.162 25.422-27.402 39.593-35.454 0.15 1.509 0.443 3.011 0.55 4.519 -15.795 23.533-17.649 23.567-17.649 23.567 4.585 17.81 10.532 35.824 10.532 54.073L-3.172 234.028zM127.016 163.194c-0.448-0.443-1.386-3.455-1.235-5.947 3.367 5.797 2.879 4.958 7.708 11.229C130.674 166.375 129.273 165.428 127.016 163.194zM203.172 234.028l-70-0.154c0-18.249 5.947-36.264 10.532-54.073 0 0-1.854-0.034-17.649-23.567 0.106-1.508 0.399-3.01 0.55-4.519 14.171 8.052 18.946 17.292 39.593 35.454 -3.516 4.183-10.083 9.766-11.559 12.619 5.315 0.984 21.982 3.298 23.393 3.477 -3.82 6.914-7.157 19.294-8.637 27.211 0.915-2.304 9.645-26.737 9.976-27.656 -4.492-0.667-10.564-2.666-23-3.84 3.028-4.536 8.998-8.736 10.845-11.758 -0.305-0.37-12.92-13.521-13.199-13.804 0.001 0 40.433 14.865 40.433 14.865 -0.611 2.267-1.479 4.439-2.262 6.653 -1.125 3.186-2.015 6.437-2.979 9.672 -2.908 9.643-1.993 4.26-8.219 28.452 6.166-15.81 13.23-38.995 14.298-44.533 4.971 0.414 6.174 3.682 7.455 8.509C206.088 209.618 204.254 221.185 203.172 234.028z",
    fill: "#0c4049",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3069",
    d: "M46.778 83.613c-2.623-1.48-8.575-8.52-11.138-7.517 -1.655 0.646-2.377 5.504-2.638 7.47 -0.333 2.525-0.929 7.711-0.328 10.185 0.725 2.985 3.631 8.507 5.37 11.027 1.468 2.122 5.211 5.797 6.407 8.088 0.759 1.454 1.493 5.373 4.083 5.12 1.674-0.164 5.537-3.072 5.744-4.452C55.406 106.057 51.943 86.528 46.778 83.613z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3070",
    d: "M43.313 99.76c-0.125-0.556 0.006-1.491 0.133-2.395 0.115-0.824 0.224-1.601 0.158-2.151 -0.251-2.06-1.66-5.975-2.578-8.097 -1.059-2.44-2.771-5.515-4.919-6.307 -0.888-0.33-1.473 0.063-1.813 0.461 -0.248 0.292-0.305 0.636-0.223 0.676 0.082 0.041 0.266-0.244 0.535-0.512 0.219-0.219 0.542-0.407 0.983-0.368 -0.178 1.026-1.091 6.582-0.696 10.369 0.311 2.978 1.489 5.202 1.673 5.536 0.028 0.352 0.073 0.695 0.139 1.028 0.869 4.347 4.648 9.29 5.963 10.908 0.243 0.298 0.496 0.476 0.56 0.404 0.062-0.074-0.087-0.368-0.33-0.668 -1.298-1.609-5.042-6.533-5.879-10.728 -0.89-4.45 2.167-11.048 2.849-12.443 0.348 0.655 0.643 1.285 0.87 1.809 0.179 0.412 0.378 0.894 0.581 1.414 -0.402 0.729-3.211 6.042-2.187 10.295 0.38 1.568 2.088 3.589 3.223 4.143 0.624 0.306 0.859 0.761 1.13 1.288 0.314 0.613 0.673 1.307 1.708 1.81 0.211 0.101 0.402 0.144 0.571 0.144 0.293 0 0.515-0.126 0.679-0.281 0.017 0.268 0.016 0.611 0.007 0.928 -0.01 0.411 0.041 0.747 0.129 0.756 0.088 0.008 0.182-0.318 0.192-0.726 0.016-0.503 0.013-1.125-0.067-1.422 -0.232-0.877-0.942-1.867-1.694-2.915C44.27 101.685 43.504 100.618 43.313 99.76zM36.538 95.905c-2.035-6.825 0-13.093 0.458-14.029 0.795 0.785 2.108 2.213 2.679 3.239C39.258 85.938 36.623 91.315 36.538 95.905zM45.318 105.891c-0.938-0.456-1.253-1.067-1.557-1.657 -0.275-0.535-0.56-1.087-1.281-1.44 -0.157-0.077-0.33-0.193-0.505-0.328 -2.324-5.988 0.254-8.606 0.899-9.142 0.199 0.731 0.346 1.403 0.411 1.941 0.061 0.495-0.05 1.28-0.156 2.041 -0.132 0.942-0.268 1.916-0.127 2.546 0.211 0.94 0.999 2.038 1.76 3.1 0.677 0.943 1.373 1.915 1.609 2.708C46.271 105.818 45.949 106.195 45.318 105.891z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3071",
    d: "M152.961 83.613c2.623-1.48 8.574-8.52 11.137-7.517 1.656 0.646 2.379 5.504 2.639 7.47 0.334 2.525 0.928 7.711 0.328 10.185 -0.725 2.985-3.631 8.507-5.371 11.027 -1.467 2.122-5.211 5.797-6.406 8.088 -0.76 1.454-1.492 5.373-4.084 5.12 -1.674-0.164-5.535-3.072-5.744-4.452C144.332 106.057 147.795 86.528 152.961 83.613z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3072",
    d: "M154.729 102.716c-0.752 1.047-1.463 2.038-1.695 2.915 -0.078 0.297-0.082 0.919-0.066 1.422 0.012 0.407 0.105 0.733 0.193 0.726 0.088-0.009 0.139-0.345 0.129-0.756 -0.01-0.316-0.01-0.66 0.006-0.928 0.164 0.155 0.387 0.281 0.68 0.281 0.168 0 0.359-0.043 0.57-0.144 1.035-0.503 1.395-1.196 1.709-1.81 0.271-0.527 0.506-0.982 1.131-1.288 1.133-0.554 2.842-2.575 3.223-4.143 1.023-4.253-1.785-9.566-2.188-10.295 0.203-0.52 0.402-1.002 0.582-1.414 0.225-0.524 0.521-1.154 0.869-1.809 0.682 1.395 3.738 7.993 2.848 12.443 -0.838 4.195-4.582 9.118-5.879 10.728 -0.242 0.3-0.393 0.594-0.33 0.668 0.064 0.071 0.318-0.106 0.561-0.404 1.314-1.618 5.094-6.561 5.963-10.908 0.066-0.333 0.111-0.677 0.139-1.028 0.184-0.334 1.363-2.558 1.674-5.536 0.395-3.788-0.518-9.343-0.695-10.369 0.441-0.039 0.764 0.149 0.982 0.368 0.268 0.268 0.453 0.552 0.535 0.512 0.08-0.041 0.023-0.384-0.223-0.676 -0.342-0.397-0.926-0.791-1.813-0.461 -2.148 0.792-3.861 3.867-4.92 6.307 -0.92 2.123-2.326 6.037-2.578 8.097 -0.066 0.55 0.043 1.328 0.158 2.151 0.127 0.904 0.256 1.839 0.133 2.395C156.234 100.618 155.469 101.685 154.729 102.716zM160.064 85.115c0.57-1.026 1.883-2.455 2.678-3.239 0.457 0.936 2.494 7.204 0.459 14.029C163.115 91.315 160.48 85.938 160.064 85.115zM153.367 105.66c0.236-0.793 0.932-1.765 1.609-2.708 0.762-1.063 1.549-2.16 1.76-3.1 0.141-0.631 0.006-1.604-0.127-2.546 -0.105-0.76-0.217-1.546-0.156-2.041 0.066-0.539 0.213-1.21 0.412-1.941 0.645 0.536 3.223 3.154 0.898 9.142 -0.176 0.134-0.348 0.25-0.504 0.328 -0.723 0.353-1.008 0.905-1.281 1.44 -0.305 0.59-0.619 1.201-1.559 1.657C153.789 106.195 153.467 105.818 153.367 105.66z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3047",
    d: "M100.002 0.867C66.384 0.92 39.082 28.536 39.134 62.56c0.009 5.403 0.704 10.643 2.002 15.634h0.001c0.012 0.054 8.12 35.809 11.82 47.522 2.775 8.787 14.288 21.989 22.398 25.322 7.826 3.217 13.039 9.828 24.646 9.828s16.82-6.611 24.646-9.828c8.11-3.333 19.624-16.535 22.398-25.322 3.7-11.713 11.809-47.468 11.819-47.522h0.002c1.298-4.992 1.994-10.231 2.002-15.634C160.923 28.536 133.62 0.92 100.002 0.867z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3048",
    d: "M140.727 16.737c10.424 11.164 16.867 26.574 16.844 43.586 -0.009 5.403-0.666 10.643-1.894 15.634h-0.001c-0.011 0.054-7.681 35.809-11.18 47.522 -2.623 8.788-13.515 21.989-21.184 25.322 -7.403 3.216-12.333 9.829-23.31 9.829 -10.978 0-15.908-6.613-23.309-9.829 -7.671-3.333-18.56-16.534-21.184-25.322 -3.5-11.713-11.168-47.468-11.18-47.522h-0.001c-1.229-4.992-1.886-10.231-1.894-15.634 -0.025-17.011 6.418-32.419 16.84-43.583C46.893 28.034 39.106 44.38 39.134 62.56c0.009 5.403 0.704 10.643 2.002 15.634h0.001c0.012 0.054 8.12 35.809 11.82 47.522 2.775 8.787 14.288 21.989 22.398 25.322 7.826 3.217 13.039 9.828 24.646 9.828s16.82-6.611 24.646-9.828c8.11-3.333 19.624-16.535 22.398-25.322 3.7-11.713 11.809-47.468 11.819-47.522h0.002c1.298-4.992 1.994-10.231 2.002-15.634C160.898 44.378 153.111 28.031 140.727 16.737z",
    fill: "#e8b9a0",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3049",
    d: "M100.002 0.867C66.384 0.92 39.082 28.536 39.134 62.56c0.009 5.403 0.704 10.643 2.002 15.634h0.001c0.012 0.054 8.12 35.809 11.82 47.522 2.775 8.787 14.288 21.989 22.398 25.322 7.826 3.217 13.039 9.828 24.646 9.828s16.82-6.611 24.646-9.828c8.11-3.333 19.624-16.535 22.398-25.322 3.7-11.713 11.809-47.468 11.819-47.522h0.002c1.298-4.992 1.994-10.231 2.002-15.634C160.923 28.536 133.62 0.92 100.002 0.867z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3059",
    d: "M100.34 141.925c-1.526 0-2.998-0.193-3.9-0.547 -0.257-0.102-0.384-0.392-0.283-0.648 0.101-0.257 0.39-0.383 0.648-0.283 1.664 0.653 5.855 0.676 7.704-0.193 0.251-0.117 0.548-0.01 0.665 0.239 0.118 0.25 0.011 0.548-0.239 0.665C103.815 141.684 102.044 141.925 100.34 141.925zM115.025 133.444c0.398-0.171 0.584-0.632 0.413-1.031s-0.635-0.583-1.031-0.413c-11.666 4.992-28.742 0.338-28.912 0.292 -0.417-0.116-0.852 0.127-0.968 0.546 -0.116 0.418 0.128 0.851 0.546 0.968 0.463 0.128 7.692 2.1 16.034 2.1C105.727 135.905 110.685 135.301 115.025 133.444z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3127",
    d: "M76.732 78.383c4.587 0.679 7.931 3.488 10.773 7.94 0.004 0.005 0.013 0.004 0.018 0.008 0.007 0.027 0.021 0.053 0.026 0.08 0.255 1.007-0.816 1.819-2.155 2.438 -4.771 0.609-9.359 1.489-14.194 0.87 -9.681-1.241-9.855-5.509-10.326-6.629 -0.252-1.101-0.325-1.417-0.311-2.473 2.332-1.366 4.043-1.647 5.854-2.005C68.541 78.194 73.268 77.868 76.732 78.383z",
    fill: "url(#SvgjsRadialGradient3128)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "translate(0.25 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3231",
    d: "M80 84c0 3.313-2.687 5.999-6 5.999S68 87.313 68 84c0-3.316 2.687-6.001 6-6.001S80 80.685 80 84z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3232",
    d: "M70.512 86.805c0.875-0.072 0.1-0.306 0.1-0.306 -0.433-0.233-1.248-0.592-1.248-0.921 0-1.031 1.414-1.299-0.034-1.705 -1.504-1.38 1.167-1.352 1.147-1.398 -0.975-2.376 0.299-1.071 0.835-1.773 1.988-2.599 0.554 0.267 1.633 0 0.391-0.096-0.78-1.531 0.034-1.33 0.539 0.132 0.662 0.58 0.662 0.58 0.393-0.077 1.008-0.682 1.008-0.682 0.749 0.226 1.275 1.29 1.043 1.091 0.368-0.045 0.884-0.221 1.286-0.341 0 0 0.07-0.239 0.139-0.033 0.917 2.661 3.284 2.47 0.559 3.24 0 0-0.176 0 0.382 0.442 2.71 2.164-2.102 1.495 0.451 2.49 0.104-0.104-1.53 0.965-1.53 1.261 0 0.501-1.042 1.818-1.946 1.3 -0.504-0.288-0.581 0.6-0.877 0.19 -0.581-0.803-1.742-0.035-1.313-0.773 0.634-0.521-0.654 0.204-0.904 0.204 -0.828 0 1.083-2.783 3.894-0.715 0.822 0.602-0.864-1.433 0.625-1.433 0.149 0.049 0.104-0.521 0.104-0.682 -0.774-0.151 1.39-0.003 1.39-1.262 0.137 0.027 0.509-0.35-1.635 0 0 0-0.068-0.75-0.034-0.886 0.11-0.438 1.214-0.298 0.904-0.75 0-0.001-0.799-1.604-0.799-1.604 -2.573-0.414-1.102-0.672-2.711-0.341 -0.076 0.378-3.445 1.984-3.338 2.729 0.1 0.702 2.115 0.938 0.208 2.182C73.405 91.051 68.437 85.454 70.512 86.805z",
    fill: "#6777b2",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3233",
    d: "M74 78.749l0.171 4.393 1.837-3.993 -1.523 4.123 3.227-2.985 -2.985 3.226 4.124-1.523 -3.992 1.839 4.392 0.17 -4.392 0.17 3.992 1.839 -4.124-1.523 2.985 3.226 -3.227-2.985 1.523 4.123 -1.837-3.993L74 89.249l-0.171-4.393 -1.838 3.993 1.522-4.123 -3.226 2.985 2.985-3.226 -4.124 1.523 3.992-1.839 -4.39-0.17 4.39-0.17 -3.992-1.839 4.124 1.523 -2.985-3.226 3.226 2.985 -1.522-4.123 1.838 3.993L74 78.749z",
    fill: "#253984",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3234",
    d: "M74.796 80.067l-0.539 3.315 1.981-2.711 -1.766 2.857 2.87-1.748 -2.725 1.964 3.319-0.515L74.668 84l3.266 0.794 -3.317-0.538 2.712 1.982 -2.858-1.765 1.748 2.869 -1.964-2.725 0.516 3.319 -0.771-3.27 -0.795 3.264 0.539-3.315 -1.984 2.711 1.768-2.857 -2.869 1.748 2.725-1.964 -3.319 0.516 3.269-0.771 -3.264-0.793 3.315 0.537 -2.712-1.982 2.858 1.765 -1.747-2.869 1.964 2.725 -0.516-3.318 0.772 3.27L74.796 80.067z",
    fill: "#152975",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3235",
    d: "M76.25 84c0 1.243-1.008 2.25-2.25 2.25s-2.25-1.007-2.25-2.25 1.008-2.25 2.25-2.25S76.25 82.757 76.25 84z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3236",
    d: "M71.637 88.311c-0.331 0.332-0.985 0.215-1.46-0.261 -0.476-0.475-0.593-1.129-0.261-1.461 0.331-0.331 0.985-0.214 1.46 0.261C71.852 87.326 71.969 87.979 71.637 88.311z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3237",
    d: "M78.806 82.818c-0.496 0.496-1.697 0.1-2.682-0.886 -0.986-0.986-1.382-2.187-0.886-2.683 0.496-0.496 1.697-0.1 2.682 0.886C78.906 81.122 79.302 82.322 78.806 82.818z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3152",
    d: "M55.112 83.583c3.224 11.315 7.475 23.313 17.685 23.669s22.135-7.239 22.29-22.238c0.173-16.767-10.474-23.381-20.684-23.737S50.307 66.714 55.112 83.583zM60.875 83.09c-0.252-1.101-0.325-1.417-0.311-2.473 2.027-1.21 4.04-1.547 5.851-1.905 2.123-0.418 6.853-0.845 10.317-0.329 4.587 0.679 7.931 3.488 10.773 7.94 0.004 0.005 0.013 0.004 0.018 0.008 0.007 0.027 0.021 0.053 0.026 0.08 0.255 1.007-0.816 1.819-2.155 2.438 -4.771 0.609-9.359 1.489-14.194 0.87C61.519 88.478 61.345 84.21 60.875 83.09z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3153",
    d: "M74.225 95.171c9.256 1.401 17.847-3.01 19.186-9.859 1.34-6.849-5.072-13.537-14.329-14.94 -9.258-1.399-17.845 3.012-19.185 9.862C58.557 87.082 64.967 93.766 74.225 95.171zM60.563 80.617c2.125-1.141 4.04-1.547 5.851-1.905 2.123-0.418 6.853-0.845 10.317-0.329 4.587 0.679 7.931 3.488 10.773 7.94 0.004 0.005 0.013 0.004 0.018 0.008 0.007 0.027 0.021 0.053 0.026 0.08 0.255 1.007-0.816 1.819-2.155 2.438 -4.771 0.609-9.359 1.489-14.194 0.87 -9.681-1.241-9.855-5.509-10.326-6.629C60.622 81.989 60.55 81.672 60.563 80.617z",
    fill: "url(#SvgjsRadialGradient3154)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3158",
    d: "M60.875 83.09c-0.252-1.101-0.325-1.417-0.311-2.473 2.092-1.175 4.04-1.547 5.851-1.905 2.123-0.418 6.853-0.845 10.317-0.329 4.587 0.679 7.931 3.488 10.773 7.94 0.004 0.005 0.013 0.004 0.018 0.008 0.007 0.027 0.021 0.053 0.026 0.08 0.255 1.007-0.816 1.819-2.155 2.438 -4.771 0.609-9.359 1.489-14.194 0.87C61.519 88.478 61.345 84.21 60.875 83.09z",
    fill: "url(#SvgjsRadialGradient3159)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3162",
    d: "M76.327 75.748c3.294 0.539 6.505 2.054 9.48 3.945 0.637 0.404 1.366 0.865 2.521 1.451 -0.828-0.188-1.594-0.617-2.309-1.011 0.736 0.698 1.422 1.529 1.982 2.334 -2.521-3.159-7.297-5.538-11.36-6.349 -3.902-0.779-10.989-0.264-16.251 2.042C65.208 75.449 72.237 75.08 76.327 75.748z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3163",
    d: "M87.508 86.277c-2.847-4.34-6.193-7.082-10.781-7.747 -4.833-0.705-11.271-0.221-15.034 1.843 -0.308 0.169-1.607 1.249-1.401 0.117 0.874-1.167 4.322-2.523 5.993-2.928C85.03 73.019 88.582 87.854 87.508 86.277zM60.646 82.841c-0.716 2.063 0.861 6.654 10.145 7.503 6.595 0.602 15.767-1.75 14.634-1.613 -4.779 0.589-9.375 1.449-14.219 0.839C60.224 88.19 61.468 83.023 60.646 82.841z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3135",
    d: "M122.867 78.383c-4.586 0.679-7.931 3.488-10.773 7.94 -0.004 0.005-0.012 0.004-0.018 0.008 -0.006 0.027-0.02 0.053-0.025 0.08 -0.256 1.007 0.815 1.819 2.154 2.438 4.771 0.609 9.359 1.489 14.194 0.87 9.681-1.241 9.855-5.509 10.325-6.629 0.253-1.101 0.325-1.417 0.312-2.473 -2.331-1.366-4.043-1.647-5.854-2.005C131.059 78.194 126.332 77.868 122.867 78.383z",
    fill: "url(#SvgjsRadialGradient3136)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "translate(-0.25 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3238",
    d: "M132,83.999c0,3.316-2.684,6-6,6s-6-2.684-6-6s2.684-6,6-6S132,80.683,132,83.999z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3239",
    d: "M122.508 86.806c0.879-0.076 0.105-0.305 0.105-0.305 -0.434-0.234-1.254-0.592-1.254-0.926 0-1.031 1.418-1.295-0.023-1.705 -1.512-1.377 1.16-1.348 1.137-1.395 -0.973-2.379 0.305-1.072 0.844-1.775 1.98-2.596 0.551 0.27 1.629 0 0.387-0.094-0.785-1.529 0.035-1.33 0.539 0.135 0.656 0.58 0.656 0.58 0.398-0.076 1.008-0.68 1.008-0.68 0.75 0.223 1.277 1.289 1.043 1.09 0.375-0.047 0.891-0.223 1.289-0.34 0 0 0.07-0.24 0.141-0.035 0.914 2.66 3.281 2.473 0.563 3.24 0 0-0.176 0 0.375 0.439 2.707 2.168-2.098 1.494 0.457 2.49 0.105-0.1-1.535 0.967-1.535 1.266 0 0.498-1.043 1.816-1.945 1.295 -0.504-0.287-0.586 0.604-0.879 0.193 -0.574-0.803-1.746-0.035-1.313-0.773 0.633-0.521-0.656 0.205-0.902 0.205 -0.832 0 1.078-2.783 3.891-0.715 0.82 0.598-0.867-1.436 0.633-1.436 0.141 0.047 0.105-0.521 0.105-0.68 -0.785-0.152 1.383-0.006 1.383-1.266 0.141 0.029 0.516-0.346-1.629 0 0 0-0.07-0.75-0.035-0.885 0.105-0.439 1.207-0.299 0.902-0.75l-0.797-1.605c-2.578-0.41-1.102-0.668-2.719-0.34 -0.07 0.381-3.445 1.986-3.34 2.73 0.105 0.703 2.121 0.938 0.211 2.18C125.402 91.054 120.434 85.452 122.508 86.806z",
    fill: "#6777b2",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3240",
    d: "M126 78.749l0.176 4.395 1.828-3.996 -1.523 4.125 3.234-2.988 -2.988 3.229 4.125-1.523 -3.996 1.84 4.395 0.17 -4.395 0.17 3.996 1.84 -4.125-1.523 2.988 3.229 -3.234-2.988 1.523 4.125 -1.828-3.996L126 89.249l-0.176-4.395 -1.84 3.996 1.523-4.125 -3.223 2.988 2.988-3.229 -4.125 1.523 3.996-1.84 -4.395-0.17 4.395-0.17 -3.996-1.84 4.125 1.523 -2.988-3.229 3.223 2.988 -1.523-4.125 1.84 3.996L126 78.749z",
    fill: "#253984",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3241",
    d: "M126.797 80.067l-0.539 3.316 1.98-2.713 -1.77 2.859 2.871-1.752 -2.719 1.969 3.316-0.516 -3.27 0.768 3.27 0.797 -3.316-0.539 2.707 1.98 -2.859-1.764 1.746 2.871 -1.957-2.725 0.516 3.316L126 84.667l-0.797 3.264 0.539-3.316 -1.98 2.713 1.77-2.859 -2.871 1.752 2.719-1.969 -3.316 0.516 3.27-0.768 -3.27-0.797 3.316 0.539 -2.707-1.98 2.859 1.764 -1.746-2.871 1.957 2.725 -0.516-3.316 0.773 3.27L126.797 80.067z",
    fill: "#152975",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3242",
    d: "M128.25 83.999c0 1.242-1.008 2.25-2.25 2.25s-2.25-1.008-2.25-2.25 1.008-2.25 2.25-2.25S128.25 82.757 128.25 83.999z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3243",
    d: "M123.633 88.312c-0.328 0.328-0.984 0.217-1.453-0.264 -0.48-0.475-0.598-1.125-0.258-1.459 0.328-0.328 0.984-0.211 1.453 0.264C123.855 87.327 123.973 87.978 123.633 88.312z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3244",
    d: "M130.805 82.815c-0.492 0.498-1.699 0.105-2.684-0.885 -0.984-0.984-1.383-2.186-0.879-2.678 0.492-0.498 1.688-0.105 2.672 0.885C130.91 81.122 131.297 82.323 130.805 82.815z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3173",
    d: "M125.197 61.277c-10.211 0.356-20.857 6.97-20.685 23.737 0.154 15 12.079 22.595 22.29 22.238 10.21-0.356 16.187-17.323 17.685-23.669C148.517 66.512 135.407 60.921 125.197 61.277zM128.399 89.719c-4.835 0.619-9.423-0.261-14.194-0.87 -1.339-0.618-2.41-1.43-2.154-2.438 0.006-0.027 0.02-0.053 0.025-0.08 0.006-0.004 0.014-0.003 0.018-0.008 2.843-4.452 6.188-7.261 10.773-7.94 3.465-0.516 8.195-0.089 10.318 0.329 1.811 0.357 3.824 0.694 5.851 1.905 0.014 1.055-0.059 1.372-0.312 2.473C138.255 84.21 138.08 88.478 128.399 89.719z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3174",
    d: "M139.703 80.234c-1.34-6.85-9.928-11.261-19.186-9.862 -9.257 1.403-15.669 8.091-14.328 14.94 1.339 6.849 9.93 11.26 19.186 9.859C134.633 93.766 141.043 87.082 139.703 80.234zM138.725 83.09c-0.47 1.121-0.645 5.388-10.325 6.629 -4.835 0.619-9.423-0.261-14.194-0.87 -1.339-0.618-2.41-1.43-2.154-2.438 0.006-0.027 0.02-0.053 0.025-0.08 0.006-0.004 0.014-0.003 0.018-0.008 2.843-4.452 6.188-7.261 10.773-7.94 3.465-0.516 8.195-0.089 10.318 0.329 1.811 0.357 3.727 0.764 5.851 1.905C139.05 81.672 138.978 81.989 138.725 83.09z",
    fill: "url(#SvgjsRadialGradient3175)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3179",
    d: "M138.725 83.09c0.253-1.101 0.325-1.417 0.312-2.473 -2.092-1.175-4.04-1.547-5.851-1.905 -2.123-0.418-6.854-0.845-10.318-0.329 -4.586 0.679-7.931 3.488-10.773 7.94 -0.004 0.005-0.012 0.004-0.018 0.008 -0.006 0.027-0.02 0.053-0.025 0.08 -0.256 1.007 0.815 1.819 2.154 2.438 4.771 0.609 9.359 1.489 14.194 0.87C138.08 88.478 138.255 84.21 138.725 83.09z",
    fill: "url(#SvgjsRadialGradient3180)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3183",
    d: "M123.273 75.748c-3.295 0.539-6.506 2.054-9.48 3.945 -0.637 0.404-1.367 0.865-2.521 1.451 0.828-0.188 1.594-0.617 2.309-1.011 -0.736 0.698-1.422 1.529-1.982 2.334 2.521-3.159 7.297-5.538 11.359-6.349 3.902-0.779 10.989-0.264 16.252 2.042C134.391 75.449 127.362 75.08 123.273 75.748z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3184",
    d: "M133.314 77.563c1.672 0.405 5.119 1.761 5.994 2.928 0.205 1.132-1.094 0.052-1.402-0.117 -3.764-2.064-10.201-2.548-15.033-1.843 -4.588 0.665-7.936 3.407-10.781 7.747C111.018 87.854 114.57 73.019 133.314 77.563zM128.395 89.57c-4.844 0.61-9.439-0.25-14.219-0.839 -1.134-0.137 8.038 2.215 14.633 1.613 9.284-0.849 10.861-5.44 10.145-7.503C138.131 83.023 139.376 88.19 128.395 89.57z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2885",
    d: "M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z",
    fill: "url(#SvgjsRadialGradient2886)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2889",
    d: "M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z",
    fill: "url(#SvgjsRadialGradient2890)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3247",
    d: "M53.149 74.996c9.743-15.115 36.491 5.148 38.018-1.191 0.299-1.271-0.407-2.015-1.564-2.492C75.982 65.807 57.955 61.18 53.149 74.996z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3248",
    d: "M146.851 74.996c-9.743-15.115-36.491 5.148-38.018-1.191 -0.299-1.271 0.407-2.015 1.564-2.492C124.018 65.807 142.045 61.18 146.851 74.996z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3063",
    d: "M100.729 120.838c-0.354 0.161-1.185 0.161-1.448-0.103 0 0-6.296-2.153-5.498-4.215 1.264-3.262 12.727-0.761 12.717 0C106.475 118.462 100.729 120.838 100.729 120.838z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3064",
    d: "M92.215 113.609c0 0 5.448-18.624 6.008-22.61 1.063 6.47-1.503 20.873-1.774 23.812 -0.329 3.569 3.455 5.688 3.455 5.688 0.293 0.371-0.061 0.602-0.516 0.456l-6.631-2.559C91.186 117.061 91.186 115.79 92.215 113.609zM103.176 116.911c0.915 0.207 1.106 0.576 1.035 0.957 -0.069 0.385-0.462 0.911-1.288 0.43 -0.907-0.526-2.619-0.767-2.619-0.767S102.261 116.701 103.176 116.911z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3021",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3019",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3255",
    d: "M152.176 96.021c-4.33-11.451-2.396-20.042-3.227-37.21 -1.283-26.428-7.483-23.179-21.749-24.214C105.156 33 97.497 22.794 81.063 22.794c-8.887 0-19.24 4.048-27.173 11.001 -6.378 43.485 2.638 39.87-6.744 61.845 -5.953-6.247-6.721-15.865-11.134-28.495 -3.519-10.451-2.658-11.011-6.527-16.049 2.484 0.449 2.734 0.429 3.842 0.429 -1.97-4.306-4.479-11.951-5.429-15.273 2.329-1.116 4.839-3.909 6.47-5.919 -0.931-2.128-1.646-4.554-2.079-6.625 0.077-0.026 0.438-0.16 0.438-0.16l0.004-0.017c5.681-2.417 6.84-15.944 10.785-19.389 1.941-1.814 3.806-2.531 5.534-3.446 0.204-1.895 0.295-2.277 0.575-3.63 9.402-2.521 12.254-1.199 25.53-4.893 4.564-1.27 7.709-2.153 17.317-1.75 3.525 1.779 16.06 10.479 25.484 1.602 7.254 4.527 13.574 5.105 22.624 10.252 15.179 8.89 17.244 15.147 16.352 29.56 10.493 13.965 8.167 30.567 3.577 47.23C157.639 89.383 154.886 92.761 152.176 96.021z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3256",
    d: "M152 82c-1-8 3-15 4-22 -1 2-3 3-3 5 0-7 3-13 2-20 -1 2-2 3-4 4 3-7 0-15-5-21 1 3 2 5 2 8 -6-9-20-10-30-15 2 3 6 5 9 7 -14-5-27-11-40-17 2.206 2.206 3.875 6.024 6.589 7.499 1.143 0.163 0.978 0.531 0 0C81.581 16.79 68.958 15.479 58 10c0 4 3 7 6 9 -3 0-6-3-8-2 -3 2 3 4 2 6 -3 2-6-1-9-1 2 3 0 8 2 11 -2-1-4-3-4-2 -1 4-3 5-3 8 0 5 3 10 3 15 0-1.608-1.938-1.279-2.697-2.127 5.009 13.975 4.782 28.692 2.606 43.497 0.082 0.089 0.154 0.184 0.237 0.271 9.382-21.975 0.366-18.36 6.744-61.845 7.933-6.953 18.286-11.001 27.173-11.001 16.435 0 24.094 10.207 46.138 11.802 14.266 1.036 20.466-2.214 21.749 24.214 0.83 17.168-1.104 25.759 3.227 37.21 0.005-0.005 0.009-0.011 0.014-0.016C152.841 88.595 155 81.796 155 75 154 77 153 79 152 82z",
    fill: "#0c080c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3257",
    d: "M159.263 71.488C158.954 72.145 157 72.343 157 73c0-3 3.516-5.243 2.924-10.264 0 0.396-3.158 2.95-3.475 3.346 -0.206 1 4.288-10.681 4.288-14.542C159.263 53.999 158 54 158 56c0-4-0.006-9.854-0.006-13.854 0 2-1.994 4.949-1.994 6.949 0.933-7.464-3.404-16.095-4.28-23.501 -0.511 1.795-1.479 3.889-0.72 5.406 -3-4-2-11-7-14 -1 2-1 4-2 6 -3-4-7-7-9-11 0 2 0 3 0 5 -5-4-12-6-15-12 0 2 0 5 0 7 -4-1-10.495-4.596-12.495-7.596C105.505 7.404 109 12 109 15c-8-4-14-10-22-14 0 2 2 4 1 6 -4-2-11.771-2-13.771-6 0 3 3.11 6 3.11 9 -9-1-11.009-3.822-19.242-7.596C57.097 4.404 56 7 55 9c-2-2-3-4-6-4 0 3 3 7 1 10 -1 1-5-3-5-2 -2 4 0 10-2 14 0 1-3-2-5-1 3.872 5.807 1.202 12.548 3.745 18.416C41.843 44.598 41.93 44.79 42 45c-0.096-0.193-0.17-0.389-0.255-0.584C40.452 41.988 36.93 41.79 36 39c0 7.303 4.157 13.774 5.645 20.932C42.15 60.233 42.404 60.788 42 62c-0.087-0.697-0.214-1.385-0.355-2.068C40.897 59.486 39.596 59.596 39 59c4.728 9.455 6.191 25.673 7.909 36.369 3.545-15.374 1.709-31.456-2.606-43.497C44.118 51.666 44 51.392 44 51c0.109 0.29 0.198 0.582 0.303 0.873C45.063 52.721 47 52.392 47 54c0-5-3-10-3-15 0-3 2-4 3-8 0-1 2 1 4 2 -2-3 0-8-2-11 3 0 6 3 9 1 1-2-5-4-2-6 2-1 5 2 8 2 -3-2-6-5-6-9 10.958 5.479 23.581 6.79 35.589 8.499C90.875 17.024 89.206 13.206 87 11c13 6 26 12 40 17 -3-2-7-4-9-7 10 5 24 6 30 15 0-3-1-5-2-8 5 6 8 14 5 21 2-1 3-2 4-4 1 7-2 13-2 20 0-2 2-3 3-5 -1 7-5 14-4 22 1-3 2-5 3-7 0 6.796-2.159 13.595-2.811 21.004 0.814-0.979 1.633-1.975 2.457-3.163C154.545 85.429 157.479 79.338 159.263 71.488z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3258",
    d: "M93.119 18.235c-1.128 0.089-2.468 0.279-4.94-0.096 -6.698-0.927-28.617-1.793-29.81-8.654 1.055 3.353 7.405 4.299 12.204 5.198 0 0 3.382 0.651 8.723 1.251C89.291 17.101 87.179 17.888 93.119 18.235zM115.897 23.746C92 13.389 93.7 14.531 88.119 10.985c7.333 6.156 9.839 6.172 22.619 12.018 5.921 2.667 7.078 2.561 15.131 4.482C120.224 25.241 119.559 25.287 115.897 23.746zM118.619 20.735c9.914 8.153 22.008 6.125 29.75 15C142.164 25.918 128.518 26.908 118.619 20.735zM59.905 17.331c-2.668-0.805-3.997-0.43-5.286 0.404 4.225-1.989 8.651 2.923 13.75 1.5C66.006 19.523 59.905 17.53 59.905 17.331zM57.051 23.932c-2.328-0.734-5.203-1.979-7.151-1.927 -1.03 0.024-1.281 0.48-1.281 0.48 0.975-1.139 5.609 1.099 8.396 1.626 0.766 0.16 1.354 0.123 1.354 0.123S57.783 24.176 57.051 23.932zM45.652 35.678c0.687-1.892 1.461-3.751 1.256-5.482 -0.104-0.627-0.309-0.955-0.289-0.96 0.464 1.973-0.313 3.175-1.68 6.136 -3.015 6.453 0.924 11.484 2.43 18.364C46.86 45.866 43.166 42.389 45.652 35.678zM154.369 45.985c0.32 2.168 0.225 3.63-0.154 7.075 0 0-0.695 5.779-2.096 11.425C154.198 59.638 155.94 51.389 154.369 45.985zM155.869 61.485c-3.387 9.387-3.936 12.846-4.5 20.25C155.099 64.497 153.284 73.154 155.869 61.485z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3259",
    d: "M114.869-1.765c-6.126 0.965-12.52 1.734-24-5.25C101.949-1.999 107.334-1.517 114.869-1.765zM128.401 0.19c-6.076-2.194-6.475-4.768-11.032-6.205 4.159 1.884 4.127 4.303 9.559 6.761 2.642 1.249 11.822 3.782 17.441 7.439C139.405 3.794 136.066 3.059 128.401 0.19zM60.619-2.015c11.593 0.241 13.441-2.719 26.75-4.25C75.403-6.414 74.136-3.561 60.619-2.015zM90.869-1.765c4.669 0.559 11.405 4.746 13.5 9.5C102.84 2.405 96.201-1.735 90.869-1.765zM116.869-0.265c4.652 2.475 6.308 7.699 12 8.75C123.284 6.637 122.178 1.803 116.869-0.265zM108.869 0.735c1.193 2.033 2.93 4.107 7.5 7C111.036 3.353 110.121 2.431 108.869 0.735zM132.119 5.485c5.115 0.627 10.451 5.663 11 11.25C143.375 11.229 138.428 5.581 132.119 5.485zM149.458 14.007c-2.307-2.946-4.339-3.642-5.339-4.022 1.428 0.741 2.997 1.725 4.866 4.386 0 0 3.437 4.57 4.884 9.614C152.871 17.907 149.458 14.007 149.458 14.007zM54.369-0.265c0.185-0.391 5.324 1.866 5.73 2.03 1.229 0.479 7.383 2.967 9.52 3.22C68.618 4.717 54.423-1.414 54.369-0.265zM45.869 5.985c0.682 0.896 1.458 2.263 2.01 3.245 0 0 0.296 0.523 0.571 1.059 0.27 0.537 0.51 1.086 0.51 1.086C49.634 12.912 49.955 13.861 50 15 50.252 12.019 47.702 7.872 45.869 5.985zM42.869 8.985c-2.517 6.149-2.489 9.708 0 16C41.306 18.681 40.986 15.697 42.869 8.985z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3260",
    d: "M157.239 31.745c0.228-3.5 0.323-5.684 0.02-9.14 -1.138-10.129-7.217-15.136-16.529-20.59 -9.158-5.208-15.513-5.751-22.811-10.37 -9.334 9.042-21.935 0.184-25.37-1.52 -16.776-0.716-14.191 2.518-32.75 4.78 -6.844 0.773-9.67 1.72-9.67 1.72 -0.26 0.07-0.52 0.13-0.76 0.2 -0.2 1-0.381 1.616-0.6 3.68 -1.516 0.801-3.484 1.572-5.45 3.41 -4.048 3.536-5.212 17.195-10.83 19.39v0.01c-0.118 0.043-0.428 0.163-0.55 0.18 0.419 2.096 1.188 4.75 2.08 6.79 -1.594 1.959-4.17 4.807-6.48 5.8 0.546 1.98 3.313 10.751 5.32 15.14 -1.1 0-2.003-0.194-4.09-0.56 4.388 5.578 3.281 5.653 6.96 16.58 4.481 12.826 5.208 22.595 11.49 28.9 5.633-10.646 5.146-15.583 5.19-19.41 0.123-5.265-2.433-18.462 1.935-42.798 9.262-8.105 22.378-12.754 34.815-9.932 13.001 2.94 19.525 9.551 38.02 10.89 14.399 1.046 20.201-2.213 21.471 23.93 0.841 17.373-1.163 26.023 3.43 37.78 2.669-3.22 5.645-6.408 8.72-17.46C165.299 62.807 167.816 45.939 157.239 31.745zM161.02 70.726c-3.468 16.597-5.491 19.609-9.061 24.96 -2.882-8.88-2.093-17.47-1.8-26.59 1.486-39.246-8.424-34.825-22.86-35.92 -17.688-1.192-24.622-7.896-37.76-10.54 -11.972-2.45-25.25 0.755-36.35 11.16 -6.045 27.128 0.578 41.608-4.78 55.37 -1.162 2.943-0.429 3.694-1.28 5.84 -4.636-6.978-5.874-16.832-7.41-21.79 -4.784-12.176-4.632-16.171-9.84-21.97 1.271 0.277 2.91 0.457 4.21 0.24 -0.01-0.01-0.01-0.01-0.01-0.02 -0.332-1.001-4.524-12.47-5.75-15.33 2.387-1.152 4.729-3.746 6.35-5.83 -1.292-4.088 0.314 1.902-2.1-6.66 7.366-2.215 6.6-16.125 14.11-21.21 0.997-0.665 1.88-1.213 2.86-1.83 0.221-1.879 0.071-0.771 0.52-3.63 8.803-1.813 12.4-0.024 25.18-4.05 9.681-2.356 16.636-2.269 17.64-2.16 6.167 3.862 9.656 6.038 16.91 5.53 3.323-0.272 5.966-1.878 8.28-4.24 4.01 3.008 8.485 4.831 13.99 7.35 22.244 10.181 24.229 18.459 24.229 32.18 1.398 1.975 2.938 5.099 3.7 7.19C164.593 50.117 163.096 61.037 161.02 70.726z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3012",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#26120b",
    strokeWidth: "none",
    opacity: 1
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1036",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1037",
    fontFamily: "\"Roboto\", \"Helvetica Neue\", Helvetica, Arial, sans-serif",
    style: {
      fontSize: "0.84em",
      fontFamily: "&quot",
      textAnchor: "middle",
      fontWeight: 400,
      display: "none"
    },
    fontSize: "0.84em",
    textAnchor: "middle",
    fontWeight: 400,
    fill: "#000000",
    x: 100,
    y: 185
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1038",
    dy: "1.2em",
    x: 100,
    style: {
      fontSize: "0.84em",
      fontFamily: "&quot",
      textAnchor: "middle",
      fontWeight: 400
    }
  }, "Created by face.co"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1001"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2886",
    cx: 100,
    cy: 114,
    r: 41,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2887",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2888",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2890",
    cx: 100,
    cy: 54,
    r: 37,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2891",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2892",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3051",
    x1: 100,
    y1: 171,
    x2: 100,
    y2: 127,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3052",
    stopOpacity: 0.8,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3053",
    stopOpacity: 1,
    stopColor: "#c27b55",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3055",
    x1: 100,
    y1: 142,
    x2: 100,
    y2: 139,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3056",
    stopOpacity: 1,
    stopColor: "#e8b9a0",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3057",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3128",
    cx: 125.903,
    cy: 85.096,
    r: 13.25,
    gradientTransform: "matrix(-1.0996 0.0423 0.0635 0.9207 206.5488 0.5932)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3129",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3130",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3131",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3132",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3133",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3134",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3136",
    cx: 125.541,
    cy: 85.113,
    r: 13.249,
    gradientTransform: "matrix(1.0996 0.0423 -0.0635 0.9207 -6.5488 0.5932)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3137",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3138",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3139",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3140",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3141",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3142",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3144",
    cx: 125.903,
    cy: 85.096,
    r: 13.25,
    gradientTransform: "matrix(-1.0996 0.0423 0.0635 0.9207 206.5488 0.5932)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3145",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3146",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3147",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3148",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3149",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3150",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3154",
    cx: 123.371,
    cy: 81.442,
    fx: 136.805,
    fy: 80.36,
    r: 17.038,
    gradientTransform: "matrix(0.9884 0.1367 0.1336 -0.7354 -56.0677 125.3)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3155",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3156",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3157",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3159",
    cx: 78.965,
    cy: 81.143,
    r: 26.237,
    gradientTransform: "matrix(0.7183 -0.06 0.0803 0.6143 8.7915 49.2595)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3160",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3161",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3165",
    cx: 125.541,
    cy: 85.113,
    r: 13.249,
    gradientTransform: "matrix(1.0996 0.0423 -0.0635 0.9207 -6.5488 0.5932)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3166",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3167",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3168",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3169",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3170",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3171",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3175",
    cx: 122.972,
    cy: 81.425,
    fx: 136.406,
    fy: 80.344,
    r: 17.037,
    gradientTransform: "matrix(-0.9884 0.1367 -0.1336 -0.7354 255.271 125.3424)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3176",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3177",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3178",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3180",
    cx: 79.515,
    cy: 81.186,
    r: 26.237,
    gradientTransform: "matrix(-0.7183 -0.06 -0.0803 0.6143 191.2076 49.2665)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3181",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3182",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3187",
    cx: -568.659,
    cy: -521.042,
    r: 59.751,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 141.2814 119.9893)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3188",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3189",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3191",
    cx: -582.838,
    cy: -519.099,
    r: 59.745,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3192",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3193",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3197",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3198",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3199",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3201",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3202",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3203",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3205",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3206",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3207",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3210",
    cx: -568.654,
    cy: -521.042,
    r: 59.752,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 193.2804 119.9894)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3211",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3212",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3214",
    cx: -582.833,
    cy: -519.102,
    r: 59.747,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3215",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3216",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3220",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3221",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3222",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3224",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3225",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3226",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3228",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3229",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3230",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cbf6fac4b560b678a42b49687828a444.svg";
export { ForwardRef as ReactComponent };